import { useTranslation } from "react-i18next";

/** Terminologia do dashboard consolidado no console da plataforma. */
export function usePlatformDashboardTerminology() {
  const { t } = useTranslation("app");
  const entityPlural = t("platformPage.tabWorkspaces", { defaultValue: "Workspaces" });
  return { entityPlural };
}
